// extracted by mini-css-extract-plugin
export var linkWrapper = "MoreCard-module--linkWrapper--1aca3";
export var overlay = "MoreCard-module--overlay--4651a";
export var wrapper = "MoreCard-module--wrapper--e1c1f";